import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {HttpClientService} from '../http-client.service';
import {Observable, throwError} from 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TextLogo, TextLogoResp} from '../models';
import {ActivatedRoute, Router} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {catchError, take, tap} from 'rxjs/operators';
import {LoaderComponent} from '../loader/loader.component';
import * as UnfairClauses from './UnFairClauses';
import {DataBagService} from "../data-bag.service";


@UntilDestroy()
@Component({
  selector: 'app-send-terms',
  templateUrl: './send-terms.component.html',
  styleUrls: ['./send-terms.component.css']
})
export class SendTermsComponent implements OnInit {

  form: FormGroup = this.formBuilder.group({
    acceptTerms: [false, Validators.requiredTrue],
    codiceFiscale: ['', Validators.required]
  });
  submitted = false;
  text: string;
  token: string;
  content$: Observable<TextLogoResp>;
  textLogo: TextLogo;
  loading = false;
  wrongCfPiva = false;
  formMessage = '';
  userName = '';
  userMessage = '';

  constructor(private formBuilder: FormBuilder,
              private httpClientService: HttpClientService,
              private dataBag: DataBagService,
              private modalService: NgbModal,
              private route: ActivatedRoute,
              private router: Router) {
  }

  get f(): any {
    return this.form.controls;
  }

  get check1(): string {
    if (this.textLogo == null || this.textLogo.check1 == null) {
      return '';
    }
    // this code strips any html in the code
    const tmp = document.createElement('DIV');
    tmp.innerHTML = this.textLogo.check1;
    return tmp.textContent || tmp.innerText || '';
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
    const loaderModal = this.modalService.open(LoaderComponent, {backdrop: 'static', keyboard: false, centered: true});
    this.loading = true;
    this.httpClientService.verifyLink(this.token).pipe(
      tap(resp => {
        loaderModal.dismiss();
        this.loading = false;
        if (resp.success !== undefined) {
          if (resp.success) {
            this.httpClientService.createPecos(this.token).pipe(
              catchError(err => {
                // this.router.navigate(['/issue']);
                console.log('Error creating pecos ' + err);
                return throwError(err);
              })
            ).subscribe();
            if (!resp.data.requiredTerms) {
              this.form.patchValue({acceptTerms: true});
            }
          } else {
            if (resp.error === 'tLink_expired') {
              this.router.navigate(['/expired']);
            } else {
              this.router.navigate(['/issue']);
            }
          }
        }
      }),
      catchError((err) => {
        loaderModal.dismiss();
        this.loading = false;
        this.router.navigate(['/issue']);
        return throwError(err);
      })
    ).subscribe();
    this.content$ = this.httpClientService.retrieveTextAndLogo(this.token);
    this.content$.pipe(
      untilDestroyed(this),
      tap(resp => {
        if (!resp.success) {
          alert('error: ' + resp.error);
          this.router.navigate(['/issue']);
        } else {
          this.textLogo = resp.data;
          this.dataBag.footer = this.textLogo.footer
          const posIndex = this.textLogo.welcomeText.indexOf('<br');
          this.userMessage = this.textLogo.welcomeText.substring(posIndex, this.textLogo.welcomeText.length); 
          this.userName = this.textLogo.welcomeText.substring(0, posIndex);
        }
      }),
      catchError((err) => {
        loaderModal.dismiss();
        this.loading = false;
        this.router.navigate(['/issue']);
        return throwError(err);
      })
    ).subscribe();
  }

  onSubmit(formMessageModal): void {
    this.submitted = true;
    if (this.form.invalid) {
      if (!this.form.value.codiceFiscale && !this.form.value.acceptTerms) {
        this.formMessage = 'Opss, non hai inserito il tuo codice fiscale/partita IVA e accettato il servizio!';
      } else if (!this.form.value.codiceFiscale) {
        this.formMessage = 'Opss, non hai inserito il tuo codice fiscale/partita IVA!';
      } else if (!this.form.value.acceptTerms) {
        this.formMessage = 'Opss, non hai ancora accettato il servizio!';
      }
      this.modalService.open(formMessageModal, {centered: true});
      return;
    }
    console.log('Form: ' + JSON.stringify(this.form.value, null, 4));
    const loaderModal = this.modalService.open(LoaderComponent, {backdrop: 'static', keyboard: false, centered: true});
    this.loading = true;
    this.httpClientService.auth(this.token,
      this.form.value.codiceFiscale,
      this.form.value.acceptTerms).pipe(
      take(1),
      tap(resp => {
        loaderModal.dismiss();
        this.loading = false;
        if (resp.success !== undefined) {
          if (resp.success) {
            localStorage.setItem('auth-token', resp.data.token);
            this.router.navigate(['/email-content/' + this.token]);
          } else {
            this.router.navigate(['/issue']);
          }
        }
      }),
      catchError((err) => {
        loaderModal.dismiss();
        this.loading = false;
        if (err.status === 401) {
          this.wrongCfPiva = true;
          this.form.get('codiceFiscale').reset('');
        } else {
          this.router.navigate(['/issue']);
        }
        if (this.wrongCfPiva) {
          setTimeout(() => {
            const errorCode = document.getElementById('errorCodeCfPiva');
            if (errorCode) {
              errorCode.focus();
            }
          });
        }
        return throwError(err);
      })
    ).subscribe();
  }

  open(modal): void {
    this.modalService.open(modal, {ariaLabelledBy: 'modal-basic-title'});
  }

  onCfCalculated(cf: string): void {
    this.form.patchValue({codiceFiscale: cf});
    this.modalService.dismissAll();
  }

  openUnfairClausesModal(): void {
    UnfairClauses('Clausole Vessatorie', this.textLogo.cgsDetail).open();
  }
}


